'use client';

import { useState } from 'react';

import {
  getAuthenticatedItems,
  guestItems,
} from '@/constants/user-dropdown-items';
import { useAuth } from '@/hooks/use-auth';
import { useLogout } from '@/hooks/use-logout';
import { Button, HoverCard, Separator } from '@holistic/components';
import { UserCircle } from '@holistic/components/icons';

import UserHoverCardItem from './user-hover-card-item';

const UserHoverCard = () => {
  const { user } = useAuth();
  const logout = useLogout();
  // Kontrollü: hover onOpenChange ile açar/kapar, click de toggle eder
  // (böylece dokunmatik/mobilde de açılabilir).
  const [open, setOpen] = useState(false);

  const items = user ? getAuthenticatedItems(logout) : guestItems;

  return (
    <HoverCard
      open={open}
      onOpenChange={setOpen}
      openDelay={100}
      closeDelay={100}
    >
      {/* asChild: tetikleyici kendi <a>'sını basmasın. href'siz <a> taranamayan
          link sayılıyordu ve içindeki butonla iç içe etkileşimli öğe oluyordu. */}
      <HoverCard.HoverCardTrigger asChild>
        <Button
          variant="ghost"
          className="text-gray-600 hover:text-gray-900"
          onClick={() => setOpen((prev) => !prev)}
        >
          <UserCircle className="shrink-0" />
          Hesabım
        </Button>
      </HoverCard.HoverCardTrigger>
      <HoverCard.HoverCardContent className="max-w-44 p-1">
        {items.map((item, index) => (
          <div key={item.label}>
            {index > 0 && <Separator className="border-border my-1 border-t" />}
            <UserHoverCardItem {...item} />
          </div>
        ))}
      </HoverCard.HoverCardContent>
    </HoverCard>
  );
};

export default UserHoverCard;
